<template>
  <div class="contentBox min-w-1400">
    <div class="formBox min-w-1400">
      <div class="inputBox max-w-1400">
        <div class="flex">
          <div class="inputGroup">
              <span class="inputLabel">Tên</span>
              <a-input
                class="smallInput"
                v-model="formValues.email">
              </a-input>
          </div>
          <div class="inputGroup">
            <span class="inputLabel">Email liên hệ</span>
            <a-input
              class="bigInput"
              v-model="formValues.mailName">
            </a-input>
          </div>
        </div>
        <div class="inputGroup">
            <span class="inputLabel">Tên công ty</span>
            <a-input
              class="smallInput"
              v-model="formValues.name">
            </a-input>
        </div>
            <span class="inputLabel">Nhu cầu của bạn</span>
            <a-textarea
              class="textareaBox"
              v-model="formValues.remark"
              placeholder="Xin vui lòng điền vào"
              :auto-size="{ minRows: 6, maxRows: 6 }"
            />
              <a-button
                type="primary"
                :disabled="
                  formValues.mailName === '' || formValues.remark === '' || formValues.email === '' || formValues.name === '' 
                "
                :class="{
                  submitButton: true,
                  btnBgcolor:
                    formValues.mailName !== '' && formValues.remark !== '' && formValues.email !== '' && formValues.name !== '' ,
                }"
                @click="submitFn"
                :loading="isLoading"
                >Gửi</a-button>
            <div class="text">
            Giờ mở cửa: Thứ Hai đến Thứ Sáu, 9:00 sáng đến 9:00 tối. 6 giờ chiều
            </div>
      </div>
    </div>
  </div>
</template>

<script>
import "./index.css";
import { message } from "ant-design-vue";

export default {
  data() {
    return {
      altText: "图片",
      formValues: {
        mailName: "",
        email: "",
        remark: "",
        name:"",
      },
    };
  },
  created() {
    this.gotoTop();
  },
  methods: {
    gotoTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    gotoPage(path) {
      this.$router.push(path);
    },
    submitFn() {
      if (this.formValues.mailName === "" || this.formValues.remark === "" || this.formValues.email === "" || this.formValues.name === "") {
        return;
      }
      this.isLoading = true;
      setTimeout(() => {
        this.isLoading = false;
        message.success(
          "Việc gửi thành công"
        );
        this.formValues = {
          mailName: "",
          email: "",
          remark: "",
          name:"",
        };
      }, 2000);
    },
  },
};
</script>

<style scoped>
.flex {
  display: flex;
  justify-content: space-between;
}
.smallInput{
  width: 400px;
}
.bigInput{
  width: 600px;
}
.inputGroup {
  margin-bottom: 40px;
}

.text{
  text-align: center;
  color: #666569;
 font-family: "Roboto";
 font-size: 20px;
 font-style: normal;
 font-weight: 400;
 line-height: normal;
 padding-top: 100px;
}

.submitButton{
  margin-top: 20px;
  width: 250px;
  height: 60px;
  font-size: 20px;
}

.contentBox {
  display: flex;
  flex-direction: column;
  background: #FCFCFC;
}
img {
  display: block;
}
.formBox {
  display: flex;
  justify-content: center;
  width: 100%;
  background-color: "";
}
.inputBox {
  margin: 0;
  overflow: hidden;
  width: 100%;
  padding: 100px 250px;
  display: flex;
  flex-direction: column;
}

.inputLabel {
  display: block;
  color: #333333;
  font-family: "Thonburi";
  font-size: 20px;
  font-weight: 700;
  padding-bottom: 10px;
}

input,
textarea {
  all: unset; /* 移除所有默认样式 */
  border: none; /* 去除边框 */
  outline: none; /* 去除聚焦时的轮廓 */
  background: none; /* 去除背景 */
  color: inherit; /* 继承父元素的文本颜色 */
  font: inherit; /* 继承父元素的字体 */
  /* border: 1px solid red; */
  height: 30px;
  flex-shrink: 0;
  border-radius: 8px;
  background: #ffffff;
  border: 1px solid #7e7e7e80;
  padding: 10px;
}

.btnBgcolor {
  background-color: #540CFA !important;
  color: #ffffff;
}
</style>
